import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import SetTrackCard from "./SetTrackCard";

export default function SortableSetTrackCard({ setTrack, ...props }) {
  const id = setTrack.id;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <SetTrackCard
      setTrack={setTrack}
      {...props}
      attributes={attributes}
      listeners={listeners}
      setNodeRef={setNodeRef}
      transform={transform}
      transition={transition}
      isDragging={isDragging}
    />
  );
}
